import React from "react";
import styles from "./styles.module.scss";

export const ErrorViewer = ({ name, touched, errors }) => {
  if (errors[name] && touched[name]) {
    return <p className={styles.required}>{errors[name]}</p>;
  }
  return null;
};
